import { useState, useEffect } from "react";
import Navbar from "../components/Navbar"; // <-- import Navbar
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
} from "recharts";

export default function Dashboard() {
  // ----------------------
  // Initial state (always arrays)
  // ----------------------
  const [lineData, setLineData] = useState([]);
  const [barData, setBarData] = useState([]);
  const [pieData, setPieData] = useState([]);

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28"];

  // ----------------------
  // Mock data for now
  // ----------------------
  useEffect(() => {
    setLineData([
      { date: "Jan", hours: 120 },
      { date: "Feb", hours: 150 },
      { date: "Mar", hours: 200 },
      { date: "Apr", hours: 170 },
      { date: "May", hours: 220 },
    ]);

    setBarData([
      { team: "Team A", completed: 40 },
      { team: "Team B", completed: 30 },
      { team: "Team C", completed: 20 },
      { team: "Team D", completed: 50 },
    ]);

    setPieData([
      { name: "Admin", value: 5 },
      { name: "Analyst", value: 15 },
      { name: "Viewer", value: 30 },
    ]);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Navbar always on top */}
      <Navbar />

      <div className="p-6">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">Dashboard</h1>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-2">Total Hours</h3>
            <p className="text-2xl font-bold">860</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-2">Active Projects</h3>
            <p className="text-2xl font-bold">12</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-2">Users</h3>
            <p className="text-2xl font-bold">50</p>
          </div>
        </div>

        {/* Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Line Chart */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-4">Hours Over Time</h3>
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={lineData || []}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                {Array.isArray(lineData) && lineData.length > 0 && (
                  <Line
                    type="monotone"
                    dataKey="hours"
                    stroke="#8884d8"
                    activeDot={{ r: 8 }}
                  />
                )}
              </LineChart>
            </ResponsiveContainer>
          </div>

          {/* Bar Chart */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-4">Tasks Completed by Team</h3>
            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={barData || []}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="team" />
                <YAxis />
                <Tooltip />
                <Legend />
                {Array.isArray(barData) && barData.length > 0 && (
                  <Bar dataKey="completed" fill="#82ca9d" />
                )}
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* Pie Chart */}
          <div className="bg-white p-6 rounded-lg shadow md:col-span-2">
            <h3 className="text-lg font-semibold mb-4">User Roles Distribution</h3>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={pieData || []}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  fill="#8884d8"
                  label
                >
                  {Array.isArray(pieData) &&
                    pieData.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
